import { Typography } from '@mui/material'
import React from 'react';
import ClientsMap from '../components/clients/ClientsMap';
import Industries from '../components/experience/Industries';
import { useTranslation } from 'react-i18next';
import Seo from '../components/seo/Seo';

function Experience(props) {
    const { t } = useTranslation('experience');
    const title = `Betonoki - ${t('ourExperience')}`;
    const description =
      t('metaDescription', {
        defaultValue:
          'Doświadczenie zespołu Betonoki: realizacje, branże i kompetencje zdobyte przy projektach w Polsce i za granicą.',
      });
    return (
        <>
            <Seo title={title} description={description} path="/experience" />
            <Typography variant='h1' sx={{mb:2}}>
                {t('ourExperience')}
                </Typography>            
            <ClientsMap/>
            <Industries/>

        </>
    );
}

export default Experience;